<template>
  <div class="home_series_zone" v-if="list.length">
    <div class="scroll_row hide_scrollbar f0">
      <div class="scroll_inner">
        <div
          v-for="(item, index) in list"
          :key="'sz-' + index"
          class="series_card"
          ref="cardEls"
          @click="cardHandle(item, index)"
        >
          <div class="series_img_wrap">
            <img
              class="series_img radius-8px"
              :src="item.img_path || '/static/images/errorimg.jpg'"
              :alt="item.ad_title || ''"
              @error="onImgError"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adExposeMixin from '../js/adExposeMixin'

/**
 * 系列栏目专区 seriesZone
 * 单项：img_path, ad_title, ad_type, ad_target
 * 后台约定最少返回 3 条，一屏展示 3 张，超过 3 张横向滑动，隐藏滚动条
 */
export default {
  name: 'homeSeriesZone',
  mixins: [adExposeMixin],
  props: {
    list: {
      type: Array,
      default: () => []
    },
    /** 埋点 flowArea 前缀，如 seriesZone */
    flow_area_prefix: {
      type: String,
      default: 'seriesZone'
    }
  },
  mounted: function () {
    this.scheduleAdExposeBindHandle(this.bindCardsExposeHandle)
  },
  watch: {
    list: function () {
      this.scheduleAdExposeBindHandle(this.bindCardsExposeHandle)
    }
  },
  methods: {
    cardHandle(item, index) {
      // 点击卡片：交给父级走公共 bannerClick，ad_type=25 时跳转系列栏目专区页
      this.$emit('card-click', item, index)
    },
    bindCardsExposeHandle: function () {
      var els = this.$refs.cardEls
      if (!els || !this.list.length) return
      if (!Array.isArray(els)) els = [els]
      for (var i = 0; i < els.length; i++) {
        if (els[i] && this.list[i]) {
          this.bindAdExposeHandle(els[i], this.flow_area_prefix + '-' + (i + 1), this.list[i])
        }
      }
    },
    onImgError(e) {
      const img = e.target
      img.src = '/static/images/errorimg.jpg'
      img.onerror = null
    }
  }
}
</script>

<style scoped lang="scss">
/* 单卡宽度：(视口 - 区块左右边距 - 两列间距) / 3 */
$strip: calc((100vw - 0.4rem) / 3);

.home_series_zone {
  margin: 0.1rem 0.11rem 0;
  box-sizing: border-box;
}

.scroll_row {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}

.scroll_inner {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.08rem;
  padding-bottom: 0.02rem;
  min-width: min-content;
}

.series_card {
  flex: 0 0 $strip;
  width: $strip;
  overflow: hidden;
}

.series_img_wrap {
  position: relative;
  width: 100%;
  height: 0.72rem;
}

.series_img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/homeSeriesZone.vue